import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from "@mui/material/styles"

declare module "@mui/material/Chip" {
  interface ChipPropsColorOverrides {
    lilac25: true
    brightBlue: true
  }

  interface ChipPropsVariantOverrides {
    pastel: true
  }
}

const MuiChipOverrides: {
  defaultProps?: ComponentsProps["MuiChip"]
  styleOverrides?: ComponentsOverrides<Theme>["MuiChip"]
  variants?: ComponentsVariants<Theme>["MuiChip"]
} = {
  styleOverrides: {
    label: ({ theme }) => ({
      ...theme.typography.body3,
    }),
  },
  variants: [
    {
      props: { size: "small" },
      style: {
        padding: "3px 4px",
        "& .MuiChip-label": {
          padding: "0 6px",
        },
      },
    },
    {
      props: { size: "medium" },
      style: {
        padding: "4px",
        "& .MuiChip-label": {
          padding: "3px 6px",
        },
      },
    },
    {
      props: { variant: "pastel", color: "success" },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.success.alert?.background,
        color: theme.palette.success.alert?.content,
      }),
    },
    {
      props: { variant: "pastel", color: "error" },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.error.alert?.background,
        color: theme.palette.error.alert?.content,
      }),
    },
    {
      props: { variant: "pastel", color: "warning" },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.warning.alert?.background,
        color: theme.palette.warning.alert?.content,
      }),
    },
    {
      props: { variant: "pastel", color: "info" },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.info.alert?.background,
        color: theme.palette.info.alert?.content,
      }),
    },
    {
      props: { variant: "pastel", color: "default" },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.eTypes.sand35,
        color: theme.palette.text.primary,
      }),
    },
    {
      props: { variant: "outlined", color: "success" },
      style: ({ theme }) => ({
        borderColor: theme.palette.success.outlinedRestingBorder,
      }),
    },
    {
      props: { variant: "outlined", color: "error" },
      style: ({ theme }) => ({
        borderColor: theme.palette.error.outlinedRestingBorder,
      }),
    },
    {
      props: { variant: "outlined", color: "warning" },
      style: ({ theme }) => ({
        borderColor: theme.palette.warning.outlinedRestingBorder,
      }),
    },
    {
      props: { variant: "outlined", color: "default" },
      style: ({ theme }) => ({
        borderColor: theme.palette.other.outlineBorder,
      }),
    },
  ],
}

export { MuiChipOverrides }
